import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import kratos_logo from '../Assets/imgs/Kratos_logo.png'


const Header = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => setIsOpen(!isOpen);

  return (
    <header className="bg-white shadow-md sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 py-4 flex items-center justify-between">
        {/* Logo Only */}
        <Link to="/" className="flex items-center">
          <img
            src={kratos_logo}
            alt="Kratos Logo"
            className="h-12 w-auto object-contain"
          />
        </Link>

        {/* Desktop Navigation */}
        <nav className="hidden md:flex gap-6 text-gray-700 font-medium">
          <Link to="/" className="hover:text-blue-600">Home</Link>
          <a href="#about">About</a>
          <a href="#partners">Partners</a>
          {/* <Link to="/contact" className="hover:text-blue-600">Contact</Link> */}
          <a href="#contact">Contact</a>
          <Link to="/products" className="hover:text-blue-600">Shop</Link>
        </nav>

        {/* Mobile Menu Toggle */}
        <button className="md:hidden focus:outline-none" onClick={toggleMenu}>
          <svg className="w-6 h-6 text-gray-800" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
            {isOpen ? (
              <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
            ) : (
              <path strokeLinecap="round" strokeLinejoin="round" d="M4 6h16M4 12h16M4 18h16" />
            )}
          </svg>
        </button>
      </div>

      {/* Mobile Dropdown Menu */}
      {/* {isOpen && (
        <div className="md:hidden px-4 pb-4 space-y-2 bg-white shadow">
          <Link to="/" className="block hover:text-blue-600">Home</Link>
          <a href="#about">About</a>
          <a href="#partners">Partners</a>
          <a href="#contact">Contact</a>
          <Link to="/products" className="block hover:text-blue-600">Products</Link>
        </div>
      )} */}
      {/* Mobile Dropdown Menu */}
{isOpen && (
  <div className="md:hidden px-4 pb-4 pt-2 bg-white shadow rounded-b-lg space-y-2">
    <Link
      to="/"
      className="block text-gray-700 font-medium py-2 px-2 rounded hover:bg-blue-100 hover:text-blue-600 transition duration-200"
    >
      Home
    </Link>
    <a
      href="#about"
      className="block text-gray-700 font-medium py-2 px-2 rounded hover:bg-blue-100 hover:text-blue-600 transition duration-200"
    >
      About
    </a>
    <a
      href="#partners"
      className="block text-gray-700 font-medium py-2 px-2 rounded hover:bg-blue-100 hover:text-blue-600 transition duration-200"
    >
      Partners
    </a>
    <a
      href="#contact"
      className="block text-gray-700 font-medium py-2 px-2 rounded hover:bg-blue-100 hover:text-blue-600 transition duration-200"
    >
      Contact
    </a>
    <Link
      to="/products"
      className="block text-gray-700 font-medium py-2 px-2 rounded hover:bg-blue-100 hover:text-blue-600 transition duration-200"
    >
      Shop
    </Link>
  </div>
)}

    </header>
  );
};

export default Header;




// import React from 'react'
// import kratos_logo from "../assets/imgs/kratos_logo.png"

// const Header = () => {
//   return (
//     <div>
//       <header className="bg-white shadow-md">
//         <div className="max-w-7xl mx-auto px-4 py-4 flex justify-between items-center">
//           <h1 className="text-2xl font-bold text-blue-600"> <img src={kratos_logo} alt="" /> </h1>
//           <nav className="hidden md:flex gap-6">
//             <a href="/" className="hover:text-blue-600">Home</a>
//             <a href="/about" className="hover:text-blue-600">About</a>
//             <a href="/products" className="hover:text-blue-600">Products</a>
//             <a href="/partners" className="hover:text-blue-600">Partners</a>
//             <a href="/contact" className="hover:text-blue-600">Contact</a>
//             <a href="/oproducts" className="hover:text-blue-600">Our Products</a>
//           </nav>
//         </div>
//       </header>
//     </div>
//   )
// }

// export default Header    